

export const floorSize = (s) => ({
    width : Math.floor(s.width ),
    height: Math.floor(s.height),
});


export const floorVector = (p) => ({
    x: Math.floor(p.x),
    y: Math.floor(p.y),
});

export const floorVector1 = (p) => {
    const a = (v) => Math.floor(Math.round(v * 1000) / 1000);
    return ({
        x: a(p.x),
        y: a(p.y),
    });
};

